import api from './api';

export const newUser = async (data: any) => {
  return await api.post('/users/', data);
};

export const addUser = async (name: string, email: string, role: string) => {
  const data = { name, email, role };
  return await api.post('/users/add/', data);
};

export const getUsers = async (query?: string) => {
  return await api.get(`/users/${query || ''}`);
};

export const updateUser = async (data: any) => {
  return await api.put(`/users/${data.id}`, data);
};

export const activeUser = async (email: string, token: string) => {
  return await api.post('/users/active/', { email, confirmacaoToken: token });
};

export const getProfile = async () => {
  const user: any = localStorage.getItem('user');
  const { id } = JSON.parse(user);
  return await api.get(`/users/${id}`);
};

export const updatePassword = async (password: string) => {
  const user: any = localStorage.getItem('user');
  const { id } = JSON.parse(user);

  return await api.put(`/users/password/${id}`, { password });
};

export const sendPasswordResetToken = async (email: string) => {
  return await api.post(`/users/send/passwordresettoken`, { email });
};

export const updatePasswordByToken = async (
  email: string,
  passwordResetToken: string,
  password: string
) => {
  return await api.put(`/users/update/pass`, {
    email,
    passwordResetToken,
    password,
  });
};
